import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { listQueryDefaults } from '../../../lib/query/listQuery';
import { getContacts } from '../api/contacts';
import type { GetContactsParams, PagedResult, ContactListItem } from '../types';

export function useContacts(
  params: GetContactsParams = {},
  options?: Pick<UseQueryOptions<PagedResult<ContactListItem>>, 'enabled'>,
) {
  return useQuery({
    queryKey: ['contacts', params],
    queryFn: () => getContacts(params),
    ...listQueryDefaults,
    ...options,
  });
}
